import { AlertTypes } from '@shared/interfaces/alert/alert-types';

/**
 * An object representing different types of alerts with their associated styles.
 * Each alert type includes a background color, a border style, and text styling.
 *
 * The keys of the object represent the name of the alert type (e.g., 'danger', 'warning', 'info'),
 * while the values are objects containing styling properties for that alert type.
 *
 * @type {Object<string, AlertTypes>}
 */
export const alertTypes: { [key: string]: AlertTypes } = {
  danger: {
    background: 'bg-red-50',
    border: 'border-red-300',
    text: 'text-red-500'
  },
  warning: {
    background: 'bg-yellow-50',
    border: 'border-yellow-300',
    text: 'text-primary'
  },
  info: {
    background: 'bg-blue-50',
    border: 'border-blue-300',
    text: 'text-blue-500'
  },
}
